import { render, staticRenderFns } from "./HomeBase.vue?vue&type=template&id=1206d751&scoped=true&lang=pug&"
import script from "./HomeBase.vue?vue&type=script&lang=js&"
export * from "./HomeBase.vue?vue&type=script&lang=js&"
import style0 from "./HomeBase.vue?vue&type=style&index=0&id=1206d751&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1206d751",
  null
  
)

export default component.exports